import { useState } from 'react'
import { useAuthForm } from '@/hooks/auth/useAuthForm'
import { registerService } from '@/services/auth'

type RegistrationFormData = {
  name: string
  email: string
  password: string
  confirmPassword: string
}

const formatName = (name: string) =>
  name.trim().replace(/\b\w/g, (c) => c.toUpperCase())

const useForm = () => {
  const [showConfirmation, setShowConfirmation] = useState(false)

  const authForm = useAuthForm<void, RegistrationFormData>({
    mutationFn: ({ confirmPassword: _discard, name, ...rest }) =>
      registerService({ name: formatName(name), ...rest }),
    onSuccess: () => setShowConfirmation(true),
  })

  return { ...authForm, showConfirmation }
}

export default useForm
